import React, {Component} from 'react';

import { MainHeader, MainFooter } from '../Components';

class PageHostingPrivacyPolicy extends Component {
    render() {
        return ( 
            <div className="App">
                <MainHeader user={this.props.user}/>
                <section className="section is-medium">
                    <div className="container">
                        <div className="content">
                            <h4 className="title is-size-4">นโยบายข้อมูลของ Ling Hosting (Alpha)</h4>
                            <p>
                                เมื่อคุณใช้บริการของเรา คุณไว้วางใจให้เรารักษาข้อมูลของคุณ นี่คือความรับผิดชอบที่ยิ่งใหญ่และพยายามอย่างยิ่งที่จะปกป้องข้อมูลของคุณ รวมถึงมอบอำนาจในการควบคุมข้อมูล
                            </p>
                            <p>
                                นโยบายความเป็นส่วนตัวนี้มีไว้เพื่อช่วยให้คุณทราบประเภทข้อมูลที่เรารวบรวม เหตุผลที่เรารวบรวม รวมถึงวิธีที่คุณจะอัปเดต จัดการ ส่งออก และลบข้อมูลดังกล่าว
                            </p>
                            <ol>
                                <li>
                                    บริการเรามีดังนี้
                                    <ul>
                                        <li>แอป</li>
                                        <li>เว็บไซต์</li>
                                        <li>รับผลิตข้อมูลแผนที่</li>
                                        <li>โฮสติง</li>
                                        <li>หากมีคำถามเกี่ยวกับนโยบายความเป็นส่วนตัวนี้ โปรดติดต่อเรา</li>
                                    </ul>
                                </li>
                                <li>
                                    ข้อมูลที่คุณสร้างหรือมอบให้กับเรา
                                    <ul>
                                        <li>
                                            คุณต้องให้ข้อมูลส่วนบุคคลกับเราซึ่งรวมถึงชื่อจริงนามสกุลจริง เบอร์โทรศัพท์ และ Email
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    เมื่อคุณแชร์ข้อมูลของคุณ
                                    <ul>
                                        <li>
                                            บริการของเราสามารถแชร์ข้อมูลเชิงพื้นที่ให้คุณแชร์ข้อมูลกับผู้อื่นได้และคุณต้องควบคุม URL ที่เราให้วิธีการแชร์ข้อมูลได้ด้วย เช่น LINK or URL ไปเผยแพรุ่สู่แบบสาธารณะได้หรือเลือกจะเก็บไว้เป็นส่วนตัวก็ได้
                                        </li>
                                    </ul>
                                </li>
                                <li>
                                    เมื่อบริษัทฯ แชร์ข้อมูลของคุณ
                                    <p>
                                        เราไม่แชร์ข้อมูลส่วนบุคคลของคุณกับบริษัทองค์กรหรือบุคคลทั่วไปนอกบริษัทฯยกเว้นในกรณีต่อไปนี้
                                    </p>
                                    <ul>
                                        <li>
                                            เมื่อได้รับความยินยอมจากคุณ
                                        </li>
                                        <li>
                                            สำหรับเหตุผลทางกฎหมาย
                                        </li>
                                        <li>
                                            เราจะแชร์ข้อมูลส่วนบุคคลออกนอกบริษัทฯ  หากเราเชื่อโดยสุจริตว่าการเข้าถึงการใช้ การเก็บรักษา หรือการเปิดเผยข้อมูลนั้นมีเหตุจำเป็นอันสมควร
                                        </li>
                                        <li>
                                            เพื่อให้เป็นไปตามกฎหมายที่มีผลบังคับใช้ ระเบียบข้อบังคับ กระบวนการทางกฎหมายหรือการร้องขอข้อมูลจากทางราชการเราแชร์ข้อมูลเกี่ยวกับจำนวนและประเภทคำขอที่ได้รับจากรัฐบาลในรายงานเพื่อความโปร่งใสของเรา
                                        </li>
                                        <li>
                                            บังคับใช้ข้อกำหนดในการให้บริการที่เกี่ยวข้องรวมถึงการตรวจสอบการละเมิดที่อาจเกิดขึ้น
                                        </li>
                                        <li>
                                            ตรวจจับ ป้องกัน หรือระบุการประพฤติมิชอบปัญหาด้านความปลอดภัยหรือด้านเทคนิค
                                        </li>
                                    </ul>
                                </li>
                            </ol>
                            <h5 className="title is-size 5">วิธีใช้ Ling Hosting</h5>
                            <ol>
                                <li>
                                    ไปที่ www.lingmaps.com/upload
                                    <ul>
                                        <li>ใส่รายละเอียด ชื่อ นามสกุล Email เบอร์โทรศัพท์</li>
                                    </ul>
                                </li>
                                <li>
                                    อัพโหลด
                                    <ul>
                                        <li>คุณสามารถอัปโหลดไฟล์จากคอมพิวเตอร์ ลง Ling Hosting</li>
                                        <li>คลิกปุ่มอัพโหลด</li>
                                        <li>เลือกไฟล์รูปแผนที่ นามสกุล .tif</li>
                                        <li>กด submit รอจนกว่าจะมีสถานะแจ้งเตือน</li>
                                    </ul>
                                </li>
                                <li>
                                    แชร์
                                    <ul>
                                        <li>คุณสามารถได้รับ URL ของภาพแผนที่ที่คุณอัพโหลด ผ่านอีเมลที่กรอกไว้ตอนอัพโหลดภาพแผนที่</li>
                                    </ul>
                                </li>
                            </ol>
                        </div>
                    </div>
                </section>
                <MainFooter />
            </div>
        )
    }
}

export default PageHostingPrivacyPolicy;


// WEBPACK FOOTER //
// ./src/PageHostingTerms/PageHostingPrivacyPolicy.js